import {debounce} from '../utils/utilities.js';
var $ = jQuery;


/**
 * Similar to the tooltip.js component, but this type of tooltip gets its
 * content from the Report references items in the page rather than a data
 * attribute.
 */

function init($context) {

  const $tooltip = $context.find('.annotation__highlight');
  const $references =  $context.find('.article__references-reference');
  const OFFSET = 5;

  var $close = {};
  var $bubble = {};
  if($tooltip.length > 0) {
    initTooltips();
  }

  function initTooltips() {
    buildBubbles();
    binds();
  }

  function binds() {
    $close =  $context.find('.tooltip__close');

    $tooltip.find('.annotation-link').on('click', openTip);
    $close.on('click', closeTip);

    $(window).on('resize', debounce(() => {
      repositionBubbles();
    }, 250));

    // // Creating the jump to the references functionality.
    // $('body').on('click', '.tooltip__jump-link', function(e) {

    //   // Prevent the default jump.
    //   e.preventDefault();

    //   // Open references accordion, if closed.
    //   openReferences();

    //   // Find the target element's name.
    //   let targetName = this.getAttribute('href').replace('#', '');

    //   // Jump to the target element.
    //   jumpTo(jQuery('[name="'+targetName+'"]'));
    // });

    // // Creating the jump back to content functionality.
    // $('body').on('click', '.reference-anchor', function(e) {

    //   // Prevent the default jump.
    //   e.preventDefault();

    //   // Find the target element's name.
    //   let targetName = this.getAttribute('href').replace('#', '');

    //   // Jump to the target element.
    //   jumpTo(jQuery(e.target).parents('article').find('[name="'+targetName+'"]'));
    // });
  }

  function buildBubbles() {
    for(let i =0; i < $tooltip.length; i++) {
      // @TODO: get toolText from the corresponding Report reference content.
      // annotation__highlight elements have a data-annotation value for this.
      let annotationLink = $($tooltip[i]).find('.annotation-link');
      let toolText = $($references[i]).find('.content').html() + '<a class="tooltip__jump-link" href="'+ annotationLink.attr('href') +'">'+ annotationLink.html() +'</a>';
      let template = createTip(toolText);
      $($tooltip[i]).append(template);
      positionBubble($($tooltip[i]));
    }

    $bubble = $('.tooltip__bubble');
  }

  function repositionBubbles() {
    for(let i = 0; i < $tooltip.length; i++) {
      positionBubble($($tooltip[i]));
    }
  }

  function positionBubble($this) {
    let $newBubble = $this.children('.tooltip__bubble');
    let leftPos = positionLeft($newBubble, $this);
    let h = $newBubble.outerHeight(true) + $this.outerHeight(true);

    $newBubble.css({'top': h * -1, 'left': leftPos });

    checkBoundaries($newBubble, $this);
  }

  function checkBoundaries($newBubble, $this) {
    let bubbleOffset = $newBubble.offset();
    let bubblePos = $newBubble.position();
    let bubbleWid = $newBubble.outerWidth(true);
    let winWidth = window.innerWidth;

    if(bubbleOffset.left < 0) {
      let addLeft = (bubbleOffset.left * -1) + bubblePos.left + OFFSET;
      $newBubble.css({'left' : addLeft});

    }
    else if(bubbleOffset.left + bubbleWid > winWidth) {
      let subLeft = bubblePos.left - ((bubbleOffset.left + bubbleWid) - winWidth) - OFFSET;
      $newBubble.css({'left': subLeft});
    }
    positionArrow($newBubble, $this);
  }

  function positionArrow($newBubble, $this) {
    let $arrow = $('.tooltip__arrow');
    let arrowPos = Math.abs($newBubble.offset().left - $this.offset().left) + ($this.outerWidth(true) /2);
    $arrow.css({'left' : arrowPos});
  }

  function positionLeft($elem, $this) {
    let elemOffset = $elem.outerWidth(true) / 2;
    let buttonOffset = $this.outerWidth() / 2;
    return (elemOffset - buttonOffset) * -1;
  }

  function closeTip(e) {
    e.preventDefault();
    e.stopPropagation();
    let ind = $close.index($(this));
    $($bubble[ind]).removeClass('_active');
  }

  function openTip(e) {

    // Prevent the default behavior of the link.
    e.preventDefault();

    // Close any other open tips.
    jQuery('.tooltip__bubble._active').removeClass('_active');

    let $child = $(this).siblings('.tooltip__bubble');

    if(!$child.hasClass('_active')) {
      $child.addClass('_active');
    }
  }

  function createTip(toolText) {
    return `<div class="tooltip__bubble"><div class="tooltip__paragraph">${toolText}</div><button class="tooltip__close heritage-icon-lightbox_close"></button><i class="tooltip__arrow" aria-hidden="true"></i></div>`;
  }

  // function jumpTo(el) {

  //   // Finding the position of the element.
  //   let elementPosition = el.offset().top;

  //   // Creating an offset, so we land with the element at the top of the screen, but below the header.
  //   let offset = 358;

  //   // Jumping the documents scroll position.
  //   document.body.scrollTop = elementPosition - offset;
  // }

  // function openReferences() {

  //   // Checking if the references bar is open already.
  //   if(!jQuery('.article__references-toggle').hasClass('_active')) {

  //     // Applying active class to the button.
  //     jQuery('.article__references-toggle').addClass('_active');

  //     // Applying height and active class to references container.
  //     jQuery('.article__references-wrapper').addClass('_active').css('height', jQuery('.article__references-wrapper').attr('data-height')+'px');
  //   }
  // }
}

export { init as tooltipAnnotations };
